var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 240,
    viewBox: "0 0 347 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.735 147.5c3.111 31.778 26.728 60.164 59.365 61.058 30.717.845 58.255-19.357 88.571-22.403 31.792-3.189 54.911 11.014 77.657 30.634 19.613 16.909 44.187 32.79 69.304 13.558 27.231-20.852 35.013-61.655 32.609-93.401-2.371-31.308-15.633-60.103-36.791-82.073C257.281 11.084 187.108-9.961 126.425 4.564 63.695 19.58 1.927 78.21 8.735 147.5z",
    fill: "#F2F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 142.267v23.214H86.214v22.321H59.43v-22.321H.5v-26.786l54.464-75.893h31.25v79.465H100.5zM59.429 94.052 25.5 142.267h33.929V94.052z",
    fill: "url(#u9cvjwesza)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M346.5 142.267v23.214h-14.286v22.321h-26.785v-22.321H246.5v-26.786l54.464-75.893h31.25v79.465H346.5zm-41.071-48.215L271.5 142.267h33.929V94.052z",
    fill: "url(#1lurkk031b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.983 36.892a2.55 2.55 0 0 0-2.866 2.293 2.55 2.55 0 0 0 2.293 2.866 2.55 2.55 0 0 0 2.866-2.293c.191-1.401-.828-2.675-2.293-2.866z",
    fill: "url(#zo9l2p5q4c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m255.168 40.777-2.738-.319a17.235 17.235 0 0 0-.383-2.611l2.484-1.083a1.331 1.331 0 0 0 .701-1.72l-.382-.892c-.319-.7-1.083-.955-1.72-.7l-2.484 1.083a8.604 8.604 0 0 0-1.656-2.039l1.656-2.23c.446-.572.319-1.4-.255-1.846l-.828-.574c-.573-.445-1.401-.318-1.847.255l-1.656 2.23c-.764-.383-1.592-.765-2.484-.956l.318-2.739c.064-.7-.446-1.401-1.146-1.465l-.956-.127c-.7-.064-1.401.446-1.465 1.146l-.318 2.74c-.892.063-1.784.19-2.612.381l-1.082-2.484a1.332 1.332 0 0 0-1.72-.7l-.892.382c-.701.318-.955 1.083-.701 1.72l1.083 2.484a8.603 8.603 0 0 0-2.038 1.656l-2.229-1.656c-.574-.446-1.402-.319-1.847.255l-.574.828c-.446.573-.318 1.4.255 1.847l2.229 1.656c-.382.764-.764 1.592-.955 2.484l-2.739-.319c-.701-.063-1.401.446-1.465 1.147l-.127 1.02c-.064.7.446 1.4 1.146 1.464l2.739.319c.064.891.191 1.783.382 2.611l-2.484 1.083a1.332 1.332 0 0 0-.7 1.72l.382.891c.318.637 1.083.956 1.719.701l2.485-1.083a8.58 8.58 0 0 0 1.656 2.038l-1.656 2.23c-.446.573-.319 1.401.254 1.847l.765.573c.573.446 1.401.319 1.847-.255l1.656-2.229c.764.382 1.592.765 2.484.956l-.318 2.738c-.064.701.445 1.402 1.146 1.465l.956.128c.7.063 1.401-.446 1.465-1.147l.318-2.739a17.175 17.175 0 0 0 2.611-.382l1.083 2.484c.319.701 1.083.956 1.72.701l.892-.382c.7-.319.955-1.083.7-1.72l-1.082-2.484a8.605 8.605 0 0 0 2.038-1.656l2.229 1.656c.573.446 1.401.318 1.847-.255l.574-.828c.446-.573.318-1.401-.255-1.847l-2.229-1.656c.382-.764.764-1.593.955-2.484l2.739.318c.7.064 1.401-.446 1.465-1.146l.127-.956c.191-.764-.382-1.401-1.083-1.528zm-7.197 1.019c-.446 4.204-4.204 7.197-8.408 6.752a7.513 7.513 0 0 1-6.688-8.408 7.513 7.513 0 0 1 8.408-6.688c4.14.446 7.134 4.204 6.688 8.344z",
    fill: "url(#w94sod2o8d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.837 37.018c-2.166-.255-4.14 1.338-4.395 3.503-.255 2.166 1.338 4.14 3.503 4.395 2.166.255 4.14-1.337 4.395-3.503a3.948 3.948 0 0 0-3.503-4.395z",
    fill: "url(#2h2zf7cqwe)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m112.398 206.217-1.942-.226a12.097 12.097 0 0 0-.271-1.851l1.761-.768a.943.943 0 0 0 .497-1.219l-.271-.632c-.226-.497-.768-.677-1.219-.497l-1.761.768a6.1 6.1 0 0 0-1.174-1.445l1.174-1.581c.316-.406.225-.993-.181-1.309l-.587-.407c-.406-.316-.993-.225-1.31.181l-1.174 1.58c-.542-.271-1.129-.541-1.761-.677l.226-1.942c.045-.496-.316-.993-.813-1.038l-.677-.091c-.497-.045-.994.316-1.039.813l-.226 1.942c-.632.045-1.264.135-1.851.271l-.768-1.761a.944.944 0 0 0-1.219-.497l-.632.271a.944.944 0 0 0-.497 1.219l.768 1.761a6.112 6.112 0 0 0-1.445 1.174l-1.58-1.174c-.407-.316-.994-.225-1.31.181l-.407.587c-.316.406-.225.994.18 1.31l1.581 1.174c-.27.542-.541 1.129-.677 1.761l-1.942-.226c-.496-.045-.993.316-1.038.813l-.09.722c-.046.497.315.994.812 1.039l1.942.226c.045.632.135 1.264.27 1.851l-1.76.768a.944.944 0 0 0-.497 1.219l.27.632c.227.452.769.678 1.22.497l1.761-.768a6.113 6.113 0 0 0 1.174 1.446l-1.174 1.58c-.316.406-.225.993.181 1.31l.542.406c.406.316.993.226 1.31-.181l1.174-1.58c.541.271 1.128.542 1.76.677l-.225 1.942c-.045.497.316.993.813 1.039l.677.09c.497.045.994-.316 1.039-.813l.225-1.942a12.092 12.092 0 0 0 1.852-.271l.768 1.762c.225.496.767.677 1.219.496l.632-.271a.944.944 0 0 0 .497-1.219l-.768-1.761a6.1 6.1 0 0 0 1.445-1.174l1.581 1.174c.406.316.993.226 1.309-.181l.407-.587c.316-.406.225-.993-.181-1.309l-1.581-1.174c.271-.542.542-1.129.678-1.762l1.942.226c.496.045.993-.316 1.038-.813l.091-.677a.883.883 0 0 0-.768-1.084zm-5.103.723a5.325 5.325 0 0 1-5.961 4.741 5.325 5.325 0 0 1-4.741-5.96 5.326 5.326 0 0 1 5.961-4.742c2.935.316 5.057 2.98 4.741 5.961z",
    fill: "url(#vws07vel5f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 203.554c-1.536-.18-2.936.948-3.116 2.484-.181 1.535.948 2.935 2.483 3.116 1.536.18 2.936-.949 3.116-2.484.181-1.58-.903-2.935-2.483-3.116z",
    fill: "url(#buqswy5iug)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m93.116 192.399-2.89-.316a14.433 14.433 0 0 0-.407-2.799l2.665-1.174a1.39 1.39 0 0 0 .722-1.852l-.406-.948a1.39 1.39 0 0 0-1.852-.723l-2.664 1.174a11.834 11.834 0 0 0-1.761-2.212l1.716-2.349c.451-.632.316-1.49-.316-1.987l-.858-.632c-.633-.451-1.49-.316-1.987.316l-1.716 2.349a16.6 16.6 0 0 0-2.62-1.039l.317-2.89a1.376 1.376 0 0 0-1.22-1.535l-1.038-.136c-.768-.09-1.49.452-1.536 1.219l-.316 2.89c-.948.046-1.896.181-2.8.407l-1.174-2.664a1.39 1.39 0 0 0-1.851-.723l-.948.406a1.39 1.39 0 0 0-.723 1.852l1.174 2.664a11.875 11.875 0 0 0-2.212 1.761l-2.349-1.716c-.632-.451-1.49-.316-1.987.316l-.632.858c-.451.633-.316 1.491.316 1.987l2.349 1.716c-.452.813-.768 1.716-1.04 2.619l-2.89-.316a1.378 1.378 0 0 0-1.535 1.22l-.135 1.038c-.09.768.452 1.49 1.264 1.536l2.89.316c.046.948.181 1.896.407 2.799l-2.664 1.175a1.389 1.389 0 0 0-.723 1.851l.407.948c.316.723 1.128 1.039 1.851.723l2.664-1.174a11.83 11.83 0 0 0 1.761 2.212l-1.716 2.349c-.451.632-.316 1.49.316 1.987l.859.632c.632.451 1.49.316 1.986-.316l1.716-2.349c.813.452 1.716.768 2.62 1.039l-.317 2.89c-.09.768.452 1.49 1.22 1.581l1.038.135a1.377 1.377 0 0 0 1.536-1.219l.316-2.89a14.408 14.408 0 0 0 2.8-.407l1.174 2.665c.316.722 1.129 1.038 1.851.722l.948-.406c.723-.316 1.039-1.129.723-1.852l-1.174-2.664a11.878 11.878 0 0 0 2.213-1.761l2.348 1.716c.632.451 1.49.316 1.987-.316l.632-.858c.451-.632.316-1.49-.316-1.987l-2.348-1.716c.451-.813.767-1.716 1.038-2.619l2.89.316c.768.09 1.49-.452 1.536-1.219l.135-1.039c.045-.768-.497-1.49-1.264-1.581zm-7.677 1.084c-.497 4.426-4.516 7.632-8.941 7.135-4.426-.497-7.632-4.516-7.135-8.941.497-4.425 4.516-7.632 8.941-7.135 4.47.497 7.632 4.516 7.135 8.941z",
    fill: "url(#82y0smd2vh)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.898 188.424c-2.303-.271-4.426 1.4-4.652 3.703-.27 2.303 1.4 4.425 3.703 4.651 2.303.271 4.426-1.4 4.651-3.703.271-2.303-1.4-4.425-3.702-4.651z",
    fill: "url(#kznhybap3i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.518 189.187c37.288 0 67.516-30.229 67.516-67.517 0-37.289-30.228-67.517-67.516-67.517-37.289 0-67.517 30.228-67.517 67.517 0 37.288 30.228 67.517 67.517 67.517z",
    fill: "url(#doj4ph45wj)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5 106.801h-96v30h96v-30z",
    fill: "url(#daltbpdmqk)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#1upncsgk6l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.236 91.415c-8.025 0-14.522-6.37-14.522-14.204 0-7.834 6.497-14.268 14.522-14.268 1.147 0 2.357.128 3.44.383l1.083.254.063-1.019c1.083-10.191 9.682-17.834 20.064-17.834 7.962 0 15.224 4.586 18.408 11.783l.255.51.573.063c5.16.319 9.618 3.758 11.211 8.536l.318.955.956-.382a13.255 13.255 0 0 1 4.968-.956c7.325 0 13.312 5.86 13.312 13.058 0 7.006-5.541 12.739-12.675 13.057h-61.976v.064z",
    fill: "url(#76qr35pqjm)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#r5ewb9gipn)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.728 192.372c-6.943 0-12.548-5.542-12.548-12.357 0-6.815 5.605-12.357 12.548-12.357 1.019 0 2.038.128 2.994.382l1.083.255.127-1.083c.892-8.79 8.408-15.478 17.389-15.478 6.879 0 13.185 4.013 15.987 10.192l.255.509.573.064c4.459.255 8.344 3.248 9.682 7.388l.319.956.955-.382c1.338-.51 2.803-.828 4.268-.828 6.369 0 11.528 5.095 11.528 11.337 0 6.051-4.84 11.02-10.955 11.338H211.728v.064z",
    fill: "url(#sh9bw7fdao)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "u9cvjwesza",
    x1: 2.412,
    y1: 108.721,
    x2: 108.917,
    y2: 165.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#002295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1lurkk031b",
    x1: 248.412,
    y1: 108.721,
    x2: 354.917,
    y2: 165.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#002295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zo9l2p5q4c",
    x1: 209.097,
    y1: 39.471,
    x2: 214.298,
    y2: 39.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w94sod2o8d",
    x1: 224.599,
    y1: 40.928,
    x2: 256.28,
    y2: 40.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2h2zf7cqwe",
    x1: 236.418,
    y1: 40.965,
    x2: 244.366,
    y2: 40.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vws07vel5f",
    x1: 90.726,
    y1: 206.325,
    x2: 113.186,
    y2: 206.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "buqswy5iug",
    x1: 99.105,
    y1: 206.353,
    x2: 104.739,
    y2: 206.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "82y0smd2vh",
    x1: 60.513,
    y1: 192.572,
    x2: 94.374,
    y2: 192.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kznhybap3i",
    x1: 73.22,
    y1: 192.599,
    x2: 81.627,
    y2: 192.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "doj4ph45wj",
    x1: 187.715,
    y1: 163.198,
    x2: 136.122,
    y2: 78.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#4567DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "daltbpdmqk",
    x1: 122.531,
    y1: 121.794,
    x2: 218.475,
    y2: 121.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#98B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "76qr35pqjm",
    x1: 132.3,
    y1: 44.727,
    x2: 132.3,
    y2: 91.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#fff",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F6F9FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sh9bw7fdao",
    x1: 238.034,
    y1: 151.734,
    x2: 238.034,
    y2: 192.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#fff",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F9FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "1upncsgk6l",
    x: 81.714,
    y: 38.727,
    width: 101.173,
    height: 58.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_307_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_307_605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r5ewb9gipn",
    x: 193.18,
    y: 145.734,
    width: 89.708,
    height: 52.638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_307_605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_307_605",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404-icon.0da2fc2c131004ca8b557a054cade3f6.svg";
export { ForwardRef as ReactComponent };